import React, { Fragment } from "react";
import scan2payBanner from "assets/images/scan2pay_banner.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import Scan2PayContent from "./content";
import Scan2PayHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Scan2Pay() {
    useDocumentTitle(
    "Accept Online Payments Instantly with Scan2Pay | YOOZ",
    "Accept Debit or Credit Card payments Online, in-store & on mobile with your unique QR Code and Payment Link. No monthly fees, terminals, apps and hidden fees."
  );
  return (
    <Fragment>
      <PageBanner img={scan2payBanner} />
      <ContentWrapper>
        <Scan2PayHeader />
        <Scan2PayContent />
      </ContentWrapper>
    </Fragment>
  );
}
